/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsAiApiKeyRetrieveParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsAiApiKeyRetrieveParams = zod.input<
    typeof ApiAccountsAiApiKeyRetrieveParams
>;
export type ApiAccountsAiApiKeyRetrieveParamsOutput = zod.output<
    typeof ApiAccountsAiApiKeyRetrieveParams
>;
